import { render, staticRenderFns } from "./NotificationsPanel.vue?vue&type=template&id=1769fcec&scoped=true"
import script from "./NotificationsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotificationsPanel.vue?vue&type=style&index=0&id=1769fcec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1769fcec",
  null
  
)

export default component.exports